import createDocumentResource from 'src/actions/shared/createDocumentResource';

export interface integrationsOrgConfig {
  isShopifyPrivateAppCustomer?: boolean;
}

const integrationsOrgConfigResource = createDocumentResource<integrationsOrgConfig>({
  name: 'integrationsOrgConfig',
  endpoint: 'v1/orgs/:orgId/configuration/integrations',
});

export default integrationsOrgConfigResource;
